<template>
  <div>
    <div
      style="z-index: 1000 !important"
      v-if="
        tarima.salida_traslado_e &&
        tarima.salida_traslado_e.tipo_traslado == 'T'
      "
      class="floated-chat-btn"
      @click="mostrarModalContar()"
    >
      <i class="fas fa-clipboard-check"></i>&nbsp;Contar
    </div>
    <div
      style="z-index: 1000 !important"
      class="floated-chat-btn"
      v-if="
        tarima.salida_traslado_e &&
        tarima.salida_traslado_e.tipo_traslado == 'D'
      "
      @click="mostrarModalContarDevolucion()"
    >
      <i class="fas fa-clipboard-check"></i>&nbsp;Contar Dev.
    </div>
    <div
      class="modal fade"
      id="contarModal"
      role="dialog"
      tabindex="-1"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Recepción de Producto</h5>
            <button
              aria-label="Close"
              class="close"
              type="button"
              @click="cancelarModal"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <form @submit="buscarProducto" v-if="producto_actual == null">
              <div class="form-group">
                <label for="">Producto</label>
                <input
                  class="form-control"
                  placeholder="Producto"
                  id="barra_producto"
                  type="text"
                  v-model="barra_producto"
                />
              </div>
              <small v-if="producto_error" class="form-text text-danger">
                {{ producto_error }}
              </small>
              <br />
              <button class="btn btn-block btn-primary" type="submit">
                Buscar Producto
              </button>
            </form>
            <form @submit="conteoDeProducto" v-if="producto_actual != null">
              <table class="table table-clean">
                <tbody>
                  <tr>
                    <td>
                      <div class="value">
                        {{ producto_actual.nombre }}
                      </div>
                      <span class="sub-value text-small">
                        {{ producto_actual.sku }}
                      </span>
                    </td>
                    <td class="text-right">
                      <div class="value"></div>
                      <span class="sub-value">
                        <span v-for="c in producto_actual.barras" :key="c"
                          >{{ c }}<br
                        /></span>
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="form-group">
                <label for="">Cantidad</label
                ><input
                  class="form-control"
                  id="total_recibida"
                  placeholder="Cantidad"
                  type="number"
                  step="0.01"
                  v-model="total_recibida"
                />
              </div>
              <div
                v-if="tarima.salida_traslado_e.tipo_traslado == 'D'"
                class="form-group"
              >
                <label>Producto Lote</label
                ><select class="form-control" v-model="producto_lote">
                  <option
                    v-for="lote in productos_lotes"
                    v-bind:key="lote.id"
                    :value="lote.id"
                  >
                    {{ lote.id }} - {{ lote.codigo_lote }} -
                    {{ lote.fecha_fabricacion }}
                  </option>
                </select>
              </div>
              <br />
              <button class="btn btn-block btn-primary" type="submit">
                Aceptar
              </button>
            </form>
            <br />
            <button
              class="btn btn-block btn-secondary"
              @click="cancelarModal"
              type="button"
            >
              Cancelar
            </button>
            <br />
            <button
              v-if="
                producto_actual != null &&
                tarima.salida_traslado_e.tipo_traslado == 'D'
              "
              class="btn btn-block btn-info"
              @click="crearNuevoLoteModal"
              type="button"
            >
              Crear nuevo lote
            </button>
          </div>
          <div class="modal-footer">
            <small v-if="error_conteo" class="form-text text-danger">
              {{ error_conteo }}
            </small>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="contarModalDevolucion"
      role="dialog"
      tabindex="-1"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header" style="padding-bottom: 1px">
            <h5 class="modal-title">Recepción de Producto</h5>
            <button
              aria-label="Close"
              class="close"
              type="button"
              @click="cancelarModal"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body" style="padding-top: 1px">
            <form @submit="buscarProducto" v-if="producto_actual == null">
              <div class="form-group">
                <label for="">Producto</label>
                <input
                  class="form-control"
                  placeholder="Producto"
                  id="barra_producto"
                  type="text"
                  v-model="barra_producto"
                />
                <small v-if="producto_error" class="form-text text-danger">
                  {{ producto_error }}
                </small>
              </div>
              <br />
              <button class="btn btn-block btn-primary" type="submit">
                Buscar Producto
              </button>
            </form>
            <form
              @submit="ContarProductoDevolucion"
              v-if="producto_actual != null"
            >
              <table class="table table-clean" style="margin-bottom: 0rem">
                <tbody>
                  <tr>
                    <td>
                      <div class="value text-success">
                        {{ producto_actual.nombre }}
                      </div>
                      <span class="sub-value text-small text-success">
                        - {{ producto_actual.sku }}
                      </span>
                    </td>
                    <td class="text-right">
                      <div class="value"></div>
                      <span class="sub-value">
                        <span v-for="c in producto_actual.barras" :key="c"
                          >{{ c }}<br
                        /></span>
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div
                v-if="tarima.salida_traslado_e.tipo_traslado == 'D'"
                class="form-group"
              >
                <div>
                  <label>Motivo Devolución</label>
                  <select v-model="motivo_devolucion" class="form-control">
                    <option :value="null">SIN MOTIVO DEVOLUCIÓN</option>
                    <option
                      v-for="(detalle, key) in motivo_devoluciones"
                      :value="detalle.id"
                      :key="key"
                    >
                      {{ detalle.descripcion }}
                    </option>
                  </select>
                  <small
                    v-if="errors && errors.motivo_devolucion"
                    class="form-text text-danger"
                    >{{ errors.motivo_devolucion[0] }}</small
                  >
                </div>
                <div>
                  <label for="">Cantidad</label
                  ><input
                    class="form-control"
                    id="total_recibida"
                    placeholder="Cantidad"
                    type="number"
                    step="0.01"
                    v-model="total_recibida"
                  />
                  <small
                    v-if="errors && errors.cantidad"
                    class="form-text text-danger"
                    >{{ errors.cantidad[0] }}</small
                  >
                </div>
                <div>
                  <label>Producto Lote</label
                  ><select class="form-control" v-model="producto_lote">
                    <option
                      v-for="lote in productos_lotes"
                      v-bind:key="lote.id"
                      :value="lote.id"
                    >
                      {{ lote.id }} - {{ lote.codigo_lote }} -
                      {{ lote.fecha_fabricacion }}
                    </option>
                  </select>
                  <small
                    v-if="errors && errors.producto_lote"
                    class="form-text text-danger"
                    >{{ errors.producto_lote[0] }}</small
                  >
                </div>
              </div>
              <div
                v-if="tarima.detalle && tarima.tarimaproductod_set"
                class="table-responsive"
              >
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col"></th>
                      <th scope="col"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="detalle in tarima.tarimaproductod_set"
                      v-bind:key="detalle.id"
                    >
                      <td
                        v-if="
                          detalle &&
                          detalle.recibida > 0 &&
                          detalle.salida_traslado_d &&
                          detalle.salida_traslado_d.producto ==
                            producto_actual.sku &&
                          detalle.salida_traslado_d.motivo_devolucion
                        "
                        v-bind:class="{
                          'table-danger': detalle.recibida != detalle.cantidad,
                        }"
                        scope="row"
                      >
                        {{
                          detalle.salida_traslado_d.motivo_devolucion
                            .descripcion
                        }}
                      </td>
                      <td
                        v-bind:class="{
                          'table-danger': detalle.recibida != detalle.cantidad,
                        }"
                        v-if="
                          detalle &&
                          detalle.recibida > 0 &&
                          detalle.salida_traslado_d &&
                          detalle.salida_traslado_d.producto ==
                            producto_actual.sku &&
                          detalle.salida_traslado_d.motivo_devolucion
                        "
                      >
                        {{ detalle.recibida }}
                        <i
                          class="fas fa-times text-danger"
                          v-if="detalle.recibida != detalle.cantidad"
                        ></i>
                        <i
                          class="fas fa-check text-success"
                          v-if="detalle.recibida == detalle.cantidad"
                        ></i>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <hr />
              </div>
              <button class="btn btn-block btn-primary" type="submit">
                <i class="fa fa-calculator"></i>
                Contar Producto
              </button>
              <br />
            </form>
            <button
              v-if="producto_actual != null"
              @click="cancelarModal()"
              class="btn btn-block btn-secondary"
            >
              <i class="fas fa-check"></i> Finalizar este conteo
            </button>
            <br />
            <button
              v-if="
                producto_actual != null &&
                tarima.salida_traslado_e.tipo_traslado == 'D'
              "
              class="btn btn-block btn-info"
              @click="crearNuevoLoteModal()"
              type="button"
            >
              <i class="fas fa-plus"></i> Crear nuevo lote
            </button>
            <div class="col-12"></div>
          </div>
          <div class="modal-footer">
            <small v-if="error_conteo" class="form-text text-danger">
              {{ error_conteo }}
            </small>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="crearloteModal"
      role="dialog"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Crear Nuevo Lote</h5>
            <button
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12">
                <label>Código Lote</label>
                <input
                  class="form-control"
                  v-model="currentLote.codigo_lote"
                  type="text"
                />
                <small
                  v-if="currentLote.err && currentLote.err.codigo_lote"
                  class="form-text text-danger"
                >
                  {{ currentLote.err.codigo_lote }}
                </small>
              </div>
              <div class="col-12">
                <br />
                <label>Fecha de Fabricación</label>
                <input
                  class="form-control"
                  v-model="currentLote.fecha_fabricacion"
                  type="date"
                />
                <small
                  v-if="currentLote.err && currentLote.err.fecha_fabricacion"
                  class="form-text text-danger"
                >
                  {{ currentLote.err.fecha_fabricacion }}
                </small>
              </div>
              <div class="col-12">
                <br />
                <label>Fecha de Vencimieno</label>
                <input
                  class="form-control"
                  v-model="currentLote.fecha_vence"
                  type="date"
                />
                <small
                  v-if="currentLote.err && currentLote.err.fecha_vence"
                  class="form-text text-danger"
                >
                  {{ currentLote.err.fecha_vence }}
                </small>
              </div>
            </div>
            <br />
            <button
              class="btn btn-block btn-success"
              @click="crearNuevoLote"
              type="button"
            >
              Guardar
            </button>
            <br />
            <button
              class="btn btn-block btn-secondary"
              @click="cancelarModal"
              type="button"
            >
              Cancelar
            </button>
          </div>
          <div class="modal-footer">
            <small v-if="error_conteo" class="form-text text-danger">
              {{ error_conteo }}
            </small>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";

export default {
  components: {},
  props: {
    tarima: {
      type: Object,
    },
  },
  data() {
    return {
      motivo_devoluciones: "",
      motivo_devolucion: "",
      currentLote: {
        producto: "",
        fecha_vence: null,
        fecha_fabricacion: null,
        codigo_lote: "",
        err: "",
      },
      errors: "",
      detalle: "",
      det: {},
      producto_lote: null,
      productos_lotes: [],
      error_conteo: null,
      producto_actual: null,
      total_recibida: null,
      barra_producto: null,
      producto_error: null,
      lote: "",
    };
  },
  mounted() {
    $("#contarModal").on("shown.bs.modal", function () {
      $("#barra_producto").trigger("focus");
    });
  },
  methods: {
    ContarProductoDevolucion(e) {
      e.preventDefault();
      if (this.barra_producto) {
        this.det.producto_barra = this.barra_producto;
      }
      if (this.total_recibida) {
        this.det.cantidad = this.total_recibida;
      }
      if (this.producto_lote) {
        this.det.lote = this.producto_lote;
      }
      if (this.motivo_devolucion) {
        this.det.motivo_devolucion = this.motivo_devolucion;
      }
      DynamicService.postAction(
        "wms",
        "tarima",
        this.tarima.id,
        "recepcionar_producto_detalle_devolucion",
        this.det
      )
        .then((response) => {
          Notifications.alert.success(
            "Contar Producto Devolución",
            "Realizado Exitosamente"
          );
          this.$emit("refresh_tarima");
          this.total_recibida = "";
          this.motivo_devolucion = "";
          this.errors = "";
        })
        .catch((errors) => {
          if (errors.response.data.detail) {
            Notifications.alert.error(
              "Contar Producto Devolución",
              errors.response.data.detail
            );
          }
          this.errors = errors.response.data;
        });
    },
    crearNuevoLoteModal() {
      let self = this;
      $("#contarModal").modal("hide");
      $("#crearloteModal").modal("show");
      self.currentLote.producto = self.producto_actual.sku;
    },
    crearNuevoLote() {
      let self = this;
      if (this.currentLote.fecha_vence) {
        this.currentLote.fecha_vence = moment(
          this.currentLote.fecha_vence
        ).format("DD/MM/YYYY");
      }
      if (this.currentLote.fecha_fabricacion) {
        this.currentLote.fecha_fabricacion = moment(
          this.currentLote.fecha_fabricacion
        ).format("DD/MM/YYYY");
      }
      DynamicService.save("cat", "producto-lote", self.currentLote)
        .then((response) => {
          self.cancelarModal();
          Notifications.alert.success("Crear lote", "Creado correctamente");
        })
        .catch((err) => {
          this.currentLote.err = err.response.data;
        });
    },
    mostrarModalContar() {
      $("#contarModal").modal("show");
    },
    mostrarModalContarDevolucion() {
      $("#contarModalDevolucion").modal("show");
      DynamicService.fetch("inv", "motivo_devolucion").then((response) => {
        this.motivo_devoluciones = response.data.results;
      });
    },
    buscarProducto(e) {
      e.preventDefault();
      let self = this;
      if (!self.barra_producto) {
        self.producto_error = "Este campo no puede ser nulo";
        return;
      }
      DynamicService.fetch("cat", "producto-barra", {
        barra: self.barra_producto,
        activo: true,
      })
        .then((res) => {
          self.producto_error = null;
          self.producto_actual = res.data.results[0].producto_obj;
          if (self.producto_actual) {
            self.refreshProductoLote(self.producto_actual);
          }
          Vue.nextTick(function () {
            $("#total_recibida").trigger("focus");
          });
        })
        .catch((err) => {
          self.producto_actual = null;
          self.producto_error = "No existe producto";
        });
    },
    refreshProductoLote(producto) {
      let self = this;
      DynamicService.getById("cat", "productos", producto.sku).then(
        (response) => {
          self.productos_lotes = response.data.productolote_set;
          self.producto_lote = self.productos_lotes[0].id;
        }
      );
    },
    cancelarModal() {
      let self = this;
      self.producto_actual = null;
      self.barra_producto = null;
      self.producto_error = null;
      self.producto_lote = null;
      self.total_recibida = null;
      self.error_conteo = null;
      self.errors = "";
      self.$emit("refresh_tarima");
      $("#contarModal").modal("hide");
      $("#contarModalDevolucion").modal("hide");
      $("#crearloteModal").modal("hide");
      self.currentLote = {
        producto: "",
        fecha_vence: null,
        fecha_fabricacion: null,
        codigo_lote: "",
      };
    },
    conteoDeProducto(e) {
      e.preventDefault();
      let self = this;
      if (self.producto_lote == null) {
        delete self.producto_lote;
      }
      DynamicService.postAction(
        "wms",
        "tarima",
        self.tarima.id,
        "recepcionar_producto",
        {
          producto_barra: self.barra_producto,
          cantidad: self.total_recibida,
          lote: self.producto_lote,
        }
      )
        .then((res) => {
          $("#contarModal").modal("hide");
          self.cancelarModal();
          self.$emit("refresh_tarima");
        })
        .catch((err) => {
          self.producto_actual = null;
          self.producto_error = null;
          self.barra_producto = null;
          self.total_recibida = null;
          self.error_conteo = null;
          if (err.response.data.detail) {
            self.error_conteo = err.response.data.detail;
          }
          Notifications.alert.error("Contar Producto", "Hubo un problema");
        });
    },
  },
};
</script>
